import * as React from 'react';
type Props = {
  className?: string;
};
export function BookWithApple({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-BookWithApple"
      className={className}
    >
      <path
        d="M5.33325 26.0001V6.00008C5.33325 5.11603 5.68444 4.26818 6.30956 3.64306C6.93468 3.01794 7.78253 2.66675 8.66659 2.66675H25.3333C25.6869 2.66675 26.026 2.80722 26.2761 3.05727C26.5261 3.30732 26.6666 3.64646 26.6666 4.00008V28.0001C26.6666 28.3537 26.5261 28.6928 26.2761 28.9429C26.026 29.1929 25.6869 29.3334 25.3333 29.3334H8.66659C7.78253 29.3334 6.93468 28.9822 6.30956 28.3571C5.68444 27.732 5.33325 26.8841 5.33325 26.0001ZM5.33325 26.0001C5.33325 25.116 5.68444 24.2682 6.30956 23.6431C6.93468 23.0179 7.78253 22.6667 8.66659 22.6667H26.6666"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10C16.5 9.72 17.39 9 18.5 9C19.1477 8.9879 19.774 9.23233 20.2423 9.68002C20.7106 10.1277 20.983 10.7424 21 11.39C21 13.5 19.5 17.5 18 17.5C17.375 17.5 16.75 16.97 16 16.97C15.25 16.97 14.625 17.5 14 17.5C12.5 17.5 11 13.5 11 11.39C11.0157 10.7419 11.2877 10.1265 11.7563 9.67854C12.2248 9.23057 12.8519 8.98658 13.5 9C14.61 9 15.5 9.72 16 10ZM16 10C16 8.5 15.5 7.75 15 7.5"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
